import React from 'react';

interface StatusBadgeProps {
    type: 'status' | 'method';
    value: number | string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ type, value }) => {
    const getStatusBadge = (statusCode: number) => {
        if (statusCode >= 200 && statusCode < 300) {
            return 'bg-green-500/20 text-green-400 border border-green-500/30';
        } else if (statusCode >= 400 && statusCode < 500) {
            return 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/30';
        } else if (statusCode >= 500) {
            return 'bg-red-500/20 text-red-400 border border-red-500/30';
        }
        return 'bg-gray-500/20 text-gray-400 border border-gray-500/30';
    };

    const getMethodBadge = (method: string) => {
        switch (method) {
            case 'GET':
                return 'bg-blue-500/20 text-blue-400 border border-blue-500/30';
            case 'POST':
                return 'bg-green-500/20 text-green-400 border border-green-500/30';
            case 'PUT':
                return 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/30';
            case 'DELETE':
                return 'bg-red-500/20 text-red-400 border border-red-500/30';
            default:
                return 'bg-gray-500/20 text-gray-400 border border-gray-500/30';
        }
    };

    const className = type === 'status' ? getStatusBadge(Number(value)) : getMethodBadge(String(value));

    return <span className={`px-2 py-1 text-xs font-semibold rounded ${className}`}>{value}</span>;
};

export default StatusBadge;
